export default __webpack_public_path__ + "static/media/favicon_custom.1c438398.ico";